// Every game the viewer, the builder and the dashboard know about. Adding a
// game = import its client entry and add one line (see docs/games-contract.md).
// Keys must match the server registry (supabase/functions/games/registry.ts).
// Order here = order in the Add ▸ Games menus and on the Games page.

import type { GameClientDef } from './types';
import { spadesClient } from './spades';
import { tonkClient } from './tonk';
import { dominoesClient } from './dominoes';
import { chessClient } from './chess';
import { checkersClient } from './checkers';
import { triviaClient } from './trivia';
import { drawingClient } from './drawing';
import { bottleClient } from './bottle';

export const GAME_REGISTRY: Record<string, GameClientDef> = {
  spades: spadesClient,
  tonk: tonkClient,
  dominoes: dominoesClient,
  chess: chessClient,
  checkers: checkersClient,
  trivia: triviaClient,
  drawing: drawingClient,
  bottle: bottleClient,
};

/** Tables placed before `game` existed are Spades. */
export const DEFAULT_GAME = 'spades';

export function getGameDef(kind: string | null | undefined): GameClientDef | undefined {
  return GAME_REGISTRY[kind || DEFAULT_GAME];
}

export const gameList = (): GameClientDef[] => Object.values(GAME_REGISTRY);

// The builder arms "place a game table" with a kind; the VR placement tool
// (which only knows the shape) reads it back when the table is dropped.
let armed: string = DEFAULT_GAME;
export function armGamePlacement(kind: string) { armed = GAME_REGISTRY[kind] ? kind : DEFAULT_GAME; }
export function armedGame(): string { return armed; }
